<div *ngIf="setupAvailable" class="setup-wizard">
  <div class="topbar"><button nz-button nzType="default" routerLink="/company/integrations">{{ 'INTEGRATION.COMMON.BACK' | translate }}</button></div>
  <h2>{{ 'INTEGRATION.SFTP.SETUP_TITLE' | translate }}</h2>
  <nz-steps class="sftp-steps" [nzCurrent]="step">
    <nz-step [nzTitle]="'INTEGRATION.SFTP.STEPS.DATA_SOURCE' | translate"></nz-step>
    <nz-step [nzTitle]="'INTEGRATION.SFTP.STEPS.PUBLIC_KEY' | translate"></nz-step>
    <nz-step [nzTitle]="'INTEGRATION.SFTP.STEPS.PROVISIONING' | translate"></nz-step>
    <nz-step [nzTitle]="'INTEGRATION.SFTP.STEPS.CONNECTION' | translate"></nz-step>
    <nz-step [nzTitle]="'INTEGRATION.SFTP.STEPS.STATUS' | translate"></nz-step>
  </nz-steps>

  <section *ngIf="!loading && !item && step === 0" class="setup-stage">
    <h3>{{ 'INTEGRATION.SFTP.DATA_SOURCE_TITLE' | translate }}</h3>
    <p>{{ 'INTEGRATION.SFTP.DATA_SOURCE_DESCRIPTION' | translate }}</p>
    <div class="data-source-brand">
      <div class="logo-box">
        <img class="provider-logo" src="/assets/integration-providers/haussoft.svg" [alt]="'INTEGRATION.SFTP.DATA_SOURCE_NAME' | translate" />
      </div>
      <strong class="data-source-name">{{ 'INTEGRATION.SFTP.DATA_SOURCE_NAME' | translate }}</strong>
    </div>
    <ul class="import-scope">
      <li>{{ 'INTEGRATION.SFTP.CAPABILITIES.PROPERTIES' | translate }}</li>
      <li>{{ 'INTEGRATION.SFTP.CAPABILITIES.CONTACTS' | translate }}</li>
      <li>{{ 'INTEGRATION.SFTP.CAPABILITIES.SERVICES' | translate }}</li>
    </ul>
    <p><b>{{ 'INTEGRATION.SFTP.SUPPORTED_FORMATS' | translate }}:</b> .xlsx / .xls</p>
    <button nz-button nzType="primary" type="button" (click)="continueToPublicKey()" [disabled]="!canConfigure">
      {{ 'INTEGRATION.SFTP.CONTINUE' | translate }}
    </button>
  </section>

  <section *ngIf="!loading && ((!item && step === 1) || (item && showKeyForm))" class="setup-stage">
    <h3>{{ 'INTEGRATION.SFTP.PUBLIC_KEY_TITLE' | translate }}</h3>
    <p>{{ 'INTEGRATION.SFTP.PUBLIC_KEY_DESCRIPTION' | translate }}</p>
    <form nz-form class="sftp-key-form" [formGroup]="keyForm">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">{{ 'INTEGRATION.SFTP.PUBLIC_KEY_LABEL' | translate }}</nz-form-label>
        <nz-form-control [nzSpan]="24" [nzErrorTip]="'INTEGRATION.SFTP.PUBLIC_KEY_INVALID' | translate">
          <textarea nz-input rows="4" formControlName="sshPublicKey" [placeholder]="'INTEGRATION.SFTP.PUBLIC_KEY_PLACEHOLDER' | translate"></textarea>
        </nz-form-control>
      </nz-form-item>
      <button nz-button nzType="primary" type="button" (click)="submitKey()" [nzLoading]="saving" [disabled]="!canConfigure || keyForm.invalid">
        {{ (item ? 'INTEGRATION.SFTP.REPLACE_KEY' : 'INTEGRATION.SFTP.SUBMIT_KEY') | translate }}
      </button>
      <button *ngIf="item" nz-button nzType="default" type="button" (click)="cancelKeyReplacement()" [disabled]="saving">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
    </form>
  </section>

  <nz-alert *ngIf="!loading && item && isAwaitingProvisioning && !showKeyForm" nzType="info" nzShowIcon
    [nzMessage]="'INTEGRATION.SFTP.AWAITING_TITLE' | translate"
    [nzDescription]="'INTEGRATION.SFTP.AWAITING_DESCRIPTION' | translate"></nz-alert>
  <div class="review setup-stage" *ngIf="!loading && item && isAwaitingProvisioning && !showKeyForm">
    <div><b>{{ 'INTEGRATION.SFTP.FINGERPRINT' | translate }}:</b> {{ item.sshKeyFingerprint || '-' }}</div>
    <button *ngIf="canConfigure" nz-button nzType="default" type="button" (click)="replaceKey()">{{ 'INTEGRATION.SFTP.REPLACE_KEY' | translate }}</button>
  </div>

  <nz-alert *ngIf="!loading && item && !isReady && !isAwaitingProvisioning && !showKeyForm" nzType="warning" nzShowIcon
    [nzMessage]="('INTEGRATION.SFTP.LIFECYCLE_LABELS.' + item.lifecycleStatus) | translate"
    [nzDescription]="'INTEGRATION.SFTP.STATUS_UNAVAILABLE' | translate"></nz-alert>

  <section *ngIf="!loading && item && isReady" class="sftp-connection-details">
    <h3>{{ 'INTEGRATION.SFTP.CONNECTION_TITLE' | translate }}</h3>
    <nz-descriptions nzBordered nzSize="small" [nzColumn]="1">
      <nz-descriptions-item [nzTitle]="'INTEGRATION.SFTP.HOST' | translate">{{ item.endpoint?.hostname }}</nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.SFTP.PORT' | translate">{{ item.endpoint?.port }}</nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.SFTP.USERNAME' | translate">{{ item.endpoint?.username }}</nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.SFTP.UPLOAD_DIRECTORY' | translate">{{ item.endpoint?.uploadDirectory }}</nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.SFTP.HOST_FINGERPRINT' | translate">{{ item.endpoint?.hostKeyFingerprint }}</nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.SFTP.REQUIRED_FILE' | translate">{{ item.acceptedFileName }}</nz-descriptions-item>
    </nz-descriptions>
    <p class="hint"><b>{{ 'INTEGRATION.SFTP.REQUIRED_FILE' | translate }}: {{ item.acceptedFileName }}</b><br>{{ 'INTEGRATION.SFTP.REQUIRED_FILE_HELP' | translate }}</p>
    <p class="hint">{{ 'INTEGRATION.SFTP.AUTO_IMPORT_DESCRIPTION' | translate }}</p>
    <button nz-button nzType="primary" (click)="manage()">{{ 'INTEGRATION.SFTP.VIEW_STATUS' | translate }}</button>
  </section>
</div>
